import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { combiner, featureKey } from './combiner';

import { PostProjectEffects } from './postProject/effects';
import { PostProjectService } from './postProject/service';
import { PostComeroundProjectEffects } from './postComeroundProject/effects';
import { PostComeroundProjectService } from './postComeroundProject/service';
import { GetProjectByIdEffects } from './getProjectById/effects';
import { GetProjectByIdService } from './getProjectById/service';
import { PutProjectEffects } from './putProject/effects';
import { PutProjectService } from './putProject/service';
import { GetCoveragesEffects } from './getCoverages/effects';
import { GetCoveragesService } from './getCoverages/service';
import { PutCoveragesEffects } from './putCoverages/effects';
import { PutCoveragesService } from './putCoverages/service';
import { SimulationEffects } from './simulation/effects';
import { SimulationService } from './simulation/service';

@NgModule({
  imports: [
    EffectsModule.forFeature([
      PostProjectEffects,
      PostComeroundProjectEffects,
      GetProjectByIdEffects,
      GetCoveragesEffects,
      PutProjectEffects,
      PutCoveragesEffects,
      SimulationEffects,
    ]),
    StoreModule.forFeature(featureKey, combiner),
  ],
  providers: [
    PostProjectService,
    PostComeroundProjectService,
    GetProjectByIdService,
    GetCoveragesService,
    PutProjectService,
    PutCoveragesService,
    SimulationService,
  ],
})
export class ProjectStoreModule {}
